import './assets/main.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faUserSecret, faPlus, faSync, faLock, faMobileAlt,
    faTimes, faDownload, faMap, faChevronLeft, faHistory
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import {getLocale, i18n, setI18nLocale} from './i18n'
import VueAxios from 'vue-axios'
import axios from "axios";
import {dateFormat} from "@/filters/dates";
import {Auth, Zapin} from "@/services/Api";
import {addThemeColor, initGtm} from "@/helpers/general";
import {injectInstallation} from "@/helpers/installation";

import Alert from "@/components/Alert.vue";
import Modal from "@/components/Modal.vue";
import FloatButton from "@/components/FloatButton.vue";
import Logo from "@/components/Logo.vue";
import { vMaska } from "maska"
import {addSentryTo} from "@/sentry";

declare const window: any;

axios.defaults.withCredentials = true;

injectInstallation()

function mountApp() {
    const app = createApp(App)

    addSentryTo(app, router)

    library.add(
        faUserSecret, faMobileAlt, faPlus, faSync, faLock,
        faMap, faDownload, faChevronLeft, faTimes, faHistory
    )

    app.component('icon', FontAwesomeIcon)
    app.component('alert', Alert)
    app.component('modal', Modal)
    app.component('float-button', FloatButton)
    app.component('logo', Logo)

    app.use(i18n)
    app.use(router)
    app.use(VueAxios, axios)

    app.directive("maska", vMaska)

    app.config.globalProperties.$filters = {
        dt(value:string, format = null) {
            return dateFormat(value, format)
        }
    }

    app.provide('axios', app.config.globalProperties.axios)

    app.mount('#app')
}

Zapin
    .configs()
    .then(async (configs:any) => {
        await setI18nLocale(i18n, getLocale())

        window.appConfig = configs.data;

        if(window.appConfig.services?.gtm?.id) {
            initGtm(window, document, 'script', 'dataLayer', window.appConfig.services.gtm.id);
        }

        addThemeColor(window.appConfig.dash.theme_color);

        await Zapin
            .updateUserData()
            .finally(async () => {
                await Auth.setAppLocaleByCurrentUser()
            })
    })
    .catch((err) => {
        console.log('Error on get configs', err)
    })
    .finally(() => mountApp())